import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';

import { ProductSortimentEntryResponse } from '@app/api/marketplace/models';
import { IColumn } from '@products/interfaces/list-table.interface';

@Component({
  selector: 'app-product-detail-list-table',
  templateUrl: './product-detail-list-table.component.html',
  styleUrls: ['./product-detail-list-table.component.scss'],
})
export class ProductDetailListTableComponent implements OnInit, AfterViewInit {
  @Input() dataSource = new MatTableDataSource<ProductSortimentEntryResponse>();
  @Input() columns: IColumn[] = [];
  @Input() isLoading: boolean = false;
  @Input() customCellValue: Function = () => null;

  @Output() public sortChangedEvent = new EventEmitter<Sort>();

  @Output() public formChanged = new EventEmitter<{
    merchantSiteId: string;
    availabilityStatus: string | null;
  }>();

  @ViewChild(MatSort) sort = new MatSort();

  readonly availableStatuses = new Map<string | null, (string | null)[]>([
    ['DISABLED', ['ENABLED', 'DISABLED', 'DISCONTINUED']],
    ['ENABLED', ['ENABLED', 'DISABLED', 'DISCONTINUED']],
    ['DISCONTINUED', ['ENABLED', 'DISCONTINUED']],
    ['READY_FOR_PRICING', ['NOT_ASSIGNED', 'READY_FOR_PRICING']],
    ['NOT_ASSIGNED', ['NOT_ASSIGNED', 'READY_FOR_PRICING']],
  ]);

  public displayedColumns: string[] = [];

  constructor(
    private dialogRef: MatDialogRef<ProductDetailListTableComponent>
  ) {}

  ngOnInit(): void {
    this.displayedColumns = this.columns.map((column: IColumn) => column.field);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.dataSource.sort = this.sort;
    });
  }

  selectionChanged(merchantSiteId: string, selected: any) {
    selected === 'null' ? (selected = null) : '';
    this.formChanged.emit({
      merchantSiteId: merchantSiteId,
      availabilityStatus: selected,
    });
  }

  goToPricing() {
    this.dialogRef.close();
  }

  public sortChanged(event: Sort): void {
    this.sortChangedEvent.emit(event);
  }
}
